import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import "LIBS/jquery.showhtml.js";
// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.PageIdModal
*
* Encapsulates the functionality of a modal dialog that contains product information.
**/
HSN.PageIdModal = (function (parent) {
    __extends(PageIdModal, parent);

    PageIdModal.EVENT = {
        SHOW_COMPLETE: 'HSN.PageIdModal.SHOW_COMPLETE'
    };

    /**
    * new HSN.PageIdModal()
    **/
    function PageIdModal() {
        return PageIdModal.__super__.constructor.call(this);
    }

    /**
    * HSN.PageIdModal#Show(elementId) -> void
    * - elementId (string): The identifier for the element to show in modal
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    PageIdModal.prototype._show = function (elementId, hideCloseButton) {
        var scope = this;

        var html = $(elementId).html();

        if (html !== undefined) {
            scope.Root.removeClass('loading');

            scope.Content.showHtml(html,
                0,
                function () {
                    scope.Center();
                    scope.Content.animate(
                        {
                            opacity: 1                        
                        },
                        {
                            complete: function () {
                                HSN.Instance().Events.Trigger(HSN.PageIdModal.EVENT.SHOW_COMPLETE, scope);
                            }
                        }
                    );
                    if (hideCloseButton) {
                        scope.Close.hide();
                    }
                    scope.Content.focus();                    
                },
                function () {
                    //scope.Center();
                });
        } else {
            $('#modal-mask').remove();
        }
    };

    return PageIdModal;

})(HSN.Modal);




// WEBPACK FOOTER //
// ./assets/js/HSN/PageIdModal.js